module.exports = __webpack_public_path__ + "static/media/skills-tickets.8a0940c5.png";